var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgStakeIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_211_86)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.9987 3.99998L5.33203 2.66665M5.33203 2.66665L3.9987 1.33331M5.33203 2.66665H3.9987C2.52594 2.66665 1.33203 3.86055 1.33203 5.33331M11.9987 12L10.6654 13.3333M10.6654 13.3333L11.9987 14.6666M10.6654 13.3333H11.9987C13.4715 13.3333 14.6654 12.1394 14.6654 10.6666M8.94348 8.94476C9.46498 9.19385 10.0489 9.33331 10.6654 9.33331C12.8745 9.33331 14.6654 7.54245 14.6654 5.33331C14.6654 3.12417 12.8745 1.33331 10.6654 1.33331C8.45623 1.33331 6.66536 3.12417 6.66536 5.33331C6.66536 5.94979 6.80482 6.53369 7.05392 7.0552M9.33203 10.6666C9.33203 12.8758 7.54117 14.6666 5.33203 14.6666C3.12289 14.6666 1.33203 12.8758 1.33203 10.6666C1.33203 8.45751 3.12289 6.66665 5.33203 6.66665C7.54117 6.66665 9.33203 8.45751 9.33203 10.6666Z",
    stroke: "white",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_211_86"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStakeIcon);
export default __webpack_public_path__ + "static/media/stake_icon.b033a3edede773a4c105e69c44909eef.svg";
export { ForwardRef as ReactComponent };